import { ElementFactory, Serializer } from 'survey-core';
import { MuiTextFieldModel, MuiTextField, TYPE as MuiTextFieldType } from '../components/questionTypes/MuiTextField';
import {
  MuiSubscriptionsModel,
  MuiSubscriptions,
  TYPE as MuiSubscriptionsType
} from '../components/questionTypes/MuiSubscription';
import { TYPE as MuiDiscountType, MuiDiscountModel, MuiDiscount } from '../components/questionTypes/MuiDiscount';
import { ReactQuestionFactory } from 'survey-react-ui';
import * as React from 'react';
import {
  MuiAdditionalProductsModel,
  MuiAdditionalProducts,
  TYPE as MuiAdditionalProductsType
} from '../components/questionTypes/MuiAdditionalProducts';
import {
  TYPE as MuiSelectableSubscriptionsType,
  MuiSelectableSubscriptionModel,
  MuiSelectableSubscriptions
} from '../components/questionTypes/MuiSelectableSubscriptions';
import { MuiCheckboxModel, MuiCheckbox, TYPE as MuiCheckboxType } from '../components/questionTypes/MuiCheckbox';
import { MuiSelectModel, MuiSelect, TYPE as MuiSelectType } from '../components/questionTypes/MuiSelect';
import {
  MuiRadioGroupModel,
  MuiRadioGroup,
  TYPE as MuiRadioGroupType
} from '../components/questionTypes/MuiRadioGroup';
import {
  MuiCompleteButton,
  MuiCompleteButtonModel,
  TYPE as MuiCompleteButtonType
} from '../components/questionTypes/MuiCompleteButton';
import {
  TYPE as MuiPrivacyConsentType,
  MuiPrivacyConsentModel,
  MuiPrivacyConsent
} from '../components/questionTypes/MuiPrivacyConsent';

export const registerCustomComponents = () => {
  ElementFactory.Instance.registerElement(MuiTextFieldType, name => new MuiTextFieldModel(name));
  ElementFactory.Instance.registerElement(MuiSubscriptionsType, name => new MuiSubscriptionsModel(name));
  ElementFactory.Instance.registerElement(MuiAdditionalProductsType, name => new MuiAdditionalProductsModel(name));
  ElementFactory.Instance.registerElement(MuiDiscountType, name => new MuiDiscountModel(name));
  ElementFactory.Instance.registerElement(
    MuiSelectableSubscriptionsType,
    name => new MuiSelectableSubscriptionModel(name)
  );
  ElementFactory.Instance.registerElement(MuiCheckboxType, name => new MuiCheckboxModel(name));
  ElementFactory.Instance.registerElement(MuiSelectType, name => new MuiSelectModel(name));
  ElementFactory.Instance.registerElement(MuiRadioGroupType, name => new MuiRadioGroupModel(name));
  ElementFactory.Instance.registerElement(MuiCompleteButtonType, name => new MuiCompleteButtonModel(name));
  ElementFactory.Instance.registerElement(MuiPrivacyConsentType, name => new MuiPrivacyConsentModel(name));

  Serializer.addClass(
    MuiTextFieldType,
    [
      { name: 'limitInput', category: 'general' },
      { name: 'inputType', category: 'general' },
      { name: 'tooltip', category: 'general' }
    ],
    () => new MuiTextFieldModel(''),
    'question'
  );

  Serializer.addClass(
    MuiSubscriptionsType,
    [
      { name: 'choices', category: 'choices' },
      { name: 'filterChoicesOnRender', category: 'choices' },
      { name: 'strings', category: 'general' },
      { name: 'productIcons', category: 'general' }
    ],
    () => new MuiSubscriptionsModel(''),
    'radiogroup'
  );

  Serializer.addClass(
    MuiSelectableSubscriptionsType,
    [
      { name: 'orderByOriginalItem', category: 'choices' },
      { name: 'filterChoicesOnRender', category: 'choices' },
      { name: 'price', category: 'general' },
      { name: 'productDetails', category: 'general' },
      { name: 'productIcons', category: 'general' },
      { name: 'strings', category: 'general' }
    ],
    () => new MuiSelectableSubscriptionModel(''),
    'radiogroup'
  );

  Serializer.addClass(
    MuiAdditionalProductsType,
    [{ name: 'selfServeText', category: 'choices' }],
    () => new MuiAdditionalProductsModel(''),
    MuiSelectableSubscriptionsType
  );

  Serializer.addClass(
    MuiDiscountType,
    [
      { name: 'validatorUrl', category: 'general' },
      { name: 'strings', category: 'general' }
    ],
    () => new MuiDiscountModel(''),
    'question'
  );

  Serializer.addClass(
    MuiCheckboxType,
    [{ name: 'links', category: 'general' }],
    () => new MuiCheckboxModel(''),
    'boolean'
  );

  Serializer.addClass(
    MuiSelectType,
    [{ name: 'choices', category: 'choices' }],
    () => new MuiSelectModel(''),
    'dropdown'
  );

  Serializer.addClass(MuiCompleteButtonType, [], () => new MuiCompleteButtonModel(''), 'question');

  Serializer.addClass(MuiRadioGroupType, [], () => new MuiRadioGroupModel(''), 'radiogroup');
  Serializer.addClass(MuiCompleteButtonType, [], () => new MuiCompleteButtonModel(''), 'question');
  Serializer.addClass(MuiPrivacyConsentType, [], () => new MuiPrivacyConsentModel(''), MuiCheckboxType);

  ReactQuestionFactory.Instance.registerQuestion(MuiTextFieldType, props => {
    return React.createElement(MuiTextField, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiSubscriptionsType, props => {
    return React.createElement(MuiSubscriptions, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiAdditionalProductsType, props => {
    return React.createElement(MuiAdditionalProducts, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiSelectableSubscriptionsType, props => {
    return React.createElement(MuiSelectableSubscriptions, props as any);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiDiscountType, props => {
    return React.createElement(MuiDiscount, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiCheckboxType, props => {
    return React.createElement(MuiCheckbox, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiSelectType, props => {
    return React.createElement(MuiSelect, props);
  });

  ReactQuestionFactory.Instance.registerQuestion(MuiRadioGroupType, props => {
    return React.createElement(MuiRadioGroup, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiCompleteButtonType, props => {
    return React.createElement(MuiCompleteButton, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiPrivacyConsentType, props => {
    return React.createElement(MuiPrivacyConsent, props);
  });
};
